// extracted by mini-css-extract-plugin
export default {"item":"ContactItem_item__3J6JV","number":"ContactItem_number__nmQR+","button":"ContactItem_button__n3YLW"};